import React, { Component } from "react";

import { Link } from "react-router-dom";
import { Modal } from "semantic-ui-react";

export default class ProductCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }
  show = dimmer => () => this.setState({ dimmer, open: true });
  close = () => this.setState({ open: false });

  render() {
    const { open, dimmer } = this.state;
    const item = this.props.item;
    return (
      <>
        <Modal
          dimmer={dimmer}
          open={open}
          onClose={this.close}
          className="modalPdf"
          closeIcon
          style={{ margin: "auto" }}
        >
          <Modal.Header>{item.name}</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <iframe
                src={item.pdfLink}
                className="pdf-view"
                title="PDF"
              ></iframe>
            </Modal.Description>
          </Modal.Content>
        </Modal>
        <div className="col-xs-12 col-sm-6 col-md-4">
          <div className="item">
            <p className="product-name">{item.name}</p>
            {item.src ? <img src={item.src} alt={item.name} className="product-image" /> : null}
            {item.pdfLink ? (
              <div className="buttons">
                <Link onClick={this.show(true)} to="#">
                  <button>View</button>
                </Link>
                <a
                  href={item.pdfLink}
                  download={item.name}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button>Download</button>
                </a>
              </div>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}
